import { useEffect } from 'react';

import { LOGIN_CONFIRM } from '@/Router/routes';
import { createAuthUrl } from '@/utils/auth';

export default function KeycloakLogin() {
  useEffect(() => {
    window.location.assign(createAuthUrl(LOGIN_CONFIRM));
  }, []);
  return null;
}
